import { type SelectHTMLAttributes, type ReactNode } from "react";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  children?: ReactNode;
}

export function Select({ children, className = "", ...rest }: SelectProps) {
  return (
    <select className={`select-kit ${className}`.trim()} {...rest}>
      {children}
    </select>
  );
}
